export const formFormat = {
    "formData": {
        "principalId": "",
        "isLandingNeeded": true,
        "formName": "",
        "formData": []
    },
    "landingPageData": {
        "principalId": "",
        "formName": "",
        "formContent": "",
        "style": {
            "background": "",
            "foregroundColor": "",
            "buttonColor": "",
            "fontFamily": "",
            "landingPageButtonColor": "",
            "landingPageButtonFont": "",
            "landingPageButtonText": "",
            "landingPageContainerContentColour": "",
            "landingPageContentType": "",
            "landingPageCustomContentColour": "",
            "landingPageCustomContentFont": "",
            "landingPageTxtColor": "",
            "buttonTextColor": "",
            "loaderColor": ""
        }
    }
}


export const inputFormat: any = {
    "title": "",
    "name": "",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "sendFileToApi": false,
    "options": [{
        "label": "",
        "placeholder": "",
        "type": "textArea",
        "name": "",
        "isRequired": true,
        "rule": { max: "" },
        "allowedFileTypes": []
    }],
    "callApiOnSelect": {
        "isActivated": false,
        "dropdown_endPoint": "",
        "searchKey": "",
        "dropDependedName": "",
        "dropdown_endPointHeaders": {},
    },
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const richTextFormat: any = {
    "title": "",
    "name": "",
    "description": "",
    "isRequired": true,
    "isDepended": false,
    "dependedId": "",
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const currencyFormat: any = {
    "title": "",
    "name": "",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "label": "",
        "placeholder": "",
        "type": "currency",
        "name": "",
        "isRequired": true
    }],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const nameSurnameFormat = {
    "title": "What is your name?",
    "name": "name",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "options": [
        {
            "label": "First Name",
            "placeholder": "Type First Name",
            "type": "text",
            "name": "submitter_firstName",
            "isRequired": true
        },
        {
            "label": "Last Name",
            "placeholder": "Type Last Name ",
            "type": "text",
            "name": "submitter_lastName",
            "isRequired": false
        }

    ],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const contactInfoFormat = {
    "title": "Contact Information",
    "name": "contact_info",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "options": [
        {
            "label": "First Name",
            "placeholder": "Type First Name",
            "type": "text",
            "name": "submitter_firstName",
            "isRequired": true,
            "rule": { "max": "" }
        },
        {
            "label": "Last Name",
            "placeholder": "Type Last Name",
            "type": "text",
            "name": "submitter_lastName",
            "isRequired": false,
            "rule": { "max": "" }
        },
        {
            "label": "Phone Number",
            "placeholder": "+1",
            "type": "phoneNumber",
            "name": "submitter_phone",
            "isRequired": false
        },
        {
            "label": "Email",
            "placeholder": "Type Email",
            "type": "email",
            "name": "submitter_email",
            "isRequired": true,
            "rule": { "max": "" }
        },
        {
            "label": "Company",
            "placeholder": "Type Company Name",
            "type": "text",
            "name": "submitter_company",
            "isRequired": false,
            "rule": { "max": "" }
        }
    ],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}


export const domainFormat = {
    "title": "Please provide the URL of your website",
    "name": "submitter_domain",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "options": [
        {
            "label": "",
            "placeholder": "https://",
            "type": "url",
            "name": "submitter_domain",
            "isRequired": true
        }

    ],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const emailFormat = {
    "title": "Enter your Email",
    "name": "submitter_email",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "options": [
        {
            "label": "",
            "placeholder": "",
            "type": "email",
            "name": "submitter_email",
            "isRequired": true
        }

    ],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const addressFormat = {
    "title": "What is your address?",
    "name": "address",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "options": [
        {
            "label": "Address",
            "placeholder": "Street address",
            "type": "text",
            "name": "submitter_address",
            "isRequired": true,
            "rule": { "max": "" }
        },
        {
            "label": "Address line 2",
            "placeholder": "Apartment, suite, etc. (optional)",
            "type": "text",
            "name": "submitter_address_line2",
            "isRequired": false,
            "rule": { "max": "" }
        },
        {
            "label": "City/Town",
            "placeholder": "City or town",
            "type": "text",
            "name": "submitter_city",
            "isRequired": true,
            "rule": { "max": "" }
        },
        {
            "label": "State/Region/Province",
            "placeholder": "State, region, or province",
            "type": "text",
            "name": "submitter_state",
            "isRequired": true,
            "rule": { "max": "" }
        },
        {
            "label": "Pincode",
            "placeholder": "Postal code",
            "type": "number",
            "name": "submitter_pincode",
            "isRequired": true,
            "rule": { "max": "" }
        },
        {
            "label": "Country",
            "placeholder": "Select country",
            "type": "country",
            "name": "submitter_country",
            "isRequired": true
        }
    ],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const multiInputFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "question": "",
        "placeholder": "",
        "type": "textArea",
        "name": "",
        "isRequired": true,
        "rule": { max: "" }
    }],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const inputPhoneFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "label": "",
        "placeholder": "",
        "type": "phoneNumber",
        "name": "",
        "isRequired": true
    }],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}
export const datetimeFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "placeholder": "",
        "type": "dateAndTime",
        "name": "",
        "isRequired": true,
        "rules": {
            "minDate": "",
            "maxDate": "",
            "showDate": [0, 1, 2, 3, 4, 5, 6]
        }
    }],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}
export const dateFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "placeholder": "",
        "type": "date",
        "name": "",
        "isRequired": true,
        "rules": {
            "minDate": "",
            "maxDate": "",
            "showDate": [0, 1, 2, 3, 4, 5, 6]
        }
    }],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const timeFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "placeholder": "",
        "type": "time",
        "name": "",
        "isRequired": true,
        "rules": {
            "minTime": "",
            "maxTime": ""
        }
    }],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const countryFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isRequired": true,
    "isDepended": false,
    "dependedId": "",
    "options": [],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}
export const geolocationFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isRequired": true,
    "isDepended": false,
    "dependedId": "",
    "options": [],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const selectFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isRequired": true,
    "isOtherEnabled": false,
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "label": "",
        "value": "",
        "score": ""
    }],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const multiselectFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isRequired": true,
    "isOtherEnabled": false,
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "label": "",
        "value": "",
        "score": "",
    },
    {
        "label": "",
        "value": "",
        "score": "",
    }],
    "isQuantity": false,
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const imageMultiselectFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isRequired": true,
    "isOtherEnabled": false,
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "label": "",
        "value": "",
        "img": ""
    },
    {
        "label": "",
        "value": "",
        "img": ""
    }],
    "isQuantity": false,
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const singleSelectFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isRequired": true,
    "isOtherEnabled": false,
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "label": "",
        "value": "",
        "score": "",
    }],
    "isQuantity": false,
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const imageSelectFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isRequired": true,
    "isOtherEnabled": false,
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "label": "",
        "value": "",
        "img": ""
    }],
    "isQuantity": false,
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const dropDownFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isRequired": true,
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "label": "",
        "value": ""
    }],
    "isSearchEnabled": false,
    "dropDependedName": "",
    "fetchFromApi": false,
    "callApiOnSelect": {
        "isActivated": false,
        "dropdown_endPoint": "",
        "searchKey": "",
        "dropDependedName": "",
        "dropdown_endPointHeaders": {},
    },
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "isMultiple": false,
    "styles": {},
    "qNo": null
}

export const htmlFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
}

export const paymentFormat = {
    "title": "",
    "name": "",
    "paymentId": "",
    "cost": "",
    "amount": "",
    "currency": "USD",
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
}

export const AppointmentJs = {
    "appointment_id": "",
    "name": "",
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
}

export const socialMedia = {
    "title": "",
    "name": "",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "isRequired": true,
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
}

export const google = {
    "title": "",
    "name": "",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "isRequired": true,
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
}

export const timeZoneFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isRequired": true,
    "isDepended": false,
    "dependedId": "",
    "options": [],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null
}

export const calculativeFieldFormat = {
    "title": "",
    "name": "",
    "isDepended": false,
    "isTimeLimitEnabled": false,
    "calculationRules": "",
    "maxDecimal": 2,
    "timeLimit": "",
    "dependedId": "",
    "styles": {},
    "qNo": null
}

export const ratingFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isRequired": true,
    "isDepended": false,
    "dependedId": "",
    "options": [],
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
    "qNo": null,
    "ratingSettings": {
        "isStar": true,
        "max": 10
    }
}

export const employeeDropdownFormat = {
    "title": "Select employee",
    "name": "",
    "description": "",
    "organizationChartId": "",
    "isRequired": true,
    "isDepended": false,
    "dependedId": "",
    "options": [{
        "label": "",
        "value": ""
    }],
    "styles": {},
    "qNo": null
}

export const captureFormat = {
    "title": "",
    "name": "",
    "description": "",
    "isDepended": false,
    "dependedId": "",
    "isRequired": true,
    "isTimeLimitEnabled": false,
    "timeLimit": "",
    "styles": {},
}

export const currencies = [
    { label: "AED", value: "AED" },
    { label: "AED", value: "AED" },
    { label: "AFN", value: "AFN" },
    { label: "ALL", value: "ALL" },
    { label: "AMD", value: "AMD" },
    { label: "ANG", value: "ANG" },
    { label: "AOA", value: "AOA" },
    { label: "ARS", value: "ARS" },
    { label: "AUD", value: "AUD" },
    { label: "AWG", value: "AWG" },
    { label: "AZN", value: "AZN" },
    { label: "BAM", value: "BAM" },
    { label: "BBD", value: "BBD" },
    { label: "BDT", value: "BDT" },
    { label: "BGN", value: "BGN" },
    { label: "BHD", value: "BHD" },
    { label: "BIF", value: "BIF" },
    { label: "BMD", value: "BMD" },
    { label: "BND", value: "BND" },
    { label: "BOB", value: "BOB" },
    { label: "BRL", value: "BRL" },
    { label: "BSD", value: "BSD" },
    { label: "BTN", value: "BTN" },
    { label: "BWP", value: "BWP" },
    { label: "BYN", value: "BYN" },
    { label: "BZD", value: "BZD" },
    { label: "CAD", value: "CAD" },
    { label: "CDF", value: "CDF" },
    { label: "CHF", value: "CHF" },
    { label: "CLP", value: "CLP" },
    { label: "CNY", value: "CNY" },
    { label: "COP", value: "COP" },
    { label: "CRC", value: "CRC" },
    { label: "CUC", value: "CUC" },
    { label: "CUP", value: "CUP" },
    { label: "CVE", value: "CVE" },
    { label: "CZK", value: "CZK" },
    { label: "DJF", value: "DJF" },
    { label: "DKK", value: "DKK" },
    { label: "DOP", value: "DOP" },
    { label: "DZD", value: "DZD" },
    { label: "EGP", value: "EGP" },
    { label: "ERN", value: "ERN" },
    { label: "ETB", value: "ETB" },
    { label: "EUR", value: "EUR" },
    { label: "FJD", value: "FJD" },
    { label: "FKP", value: "FKP" },
    { label: "GBP", value: "GBP" },
    { label: "GEL", value: "GEL" },
    { label: "GHS", value: "GHS" },
    { label: "GIP", value: "GIP" },
    { label: "GMD", value: "GMD" },
    { label: "GNF", value: "GNF" },
    { label: "GTQ", value: "GTQ" },
    { label: "GYD", value: "GYD" },
    { label: "HKD", value: "HKD" },
    { label: "HNL", value: "HNL" },
    { label: "HRK", value: "HRK" },
    { label: "HTG", value: "HTG" },
    { label: "HUF", value: "HUF" },
    { label: "IDR", value: "IDR" },
    { label: "ILS", value: "ILS" },
    { label: "INR", value: "INR" },
    { label: "IQD", value: "IQD" },
    { label: "IRR", value: "IRR" },
    { label: "ISK", value: "ISK" },
    { label: "JMD", value: "JMD" },
    { label: "JOD", value: "JOD" },
    { label: "JPY", value: "JPY" },
    { label: "KES", value: "KES" },
    { label: "KGS", value: "KGS" },
    { label: "KHR", value: "KHR" },
    { label: "KMF", value: "KMF" },
    { label: "KPW", value: "KPW" },
    { label: "KRW", value: "KRW" },
    { label: "KWD", value: "KWD" },
    { label: "KYD", value: "KYD" },
    { label: "KZT", value: "KZT" },
    { label: "LAK", value: "LAK" },
    { label: "LBP", value: "LBP" },
    { label: "LKR", value: "LKR" },
    { label: "LRD", value: "LRD" },
    { label: "LSL", value: "LSL" },
    { label: "LYD", value: "LYD" },
    { label: "MAD", value: "MAD" },
    { label: "MDL", value: "MDL" },
    { label: "MGA", value: "MGA" },
    { label: "MKD", value: "MKD" },
    { label: "MMK", value: "MMK" },
    { label: "MNT", value: "MNT" },
    { label: "MOP", value: "MOP" },
    { label: "MRU", value: "MRU" },
    { label: "MUR", value: "MUR" },
    { label: "MVR", value: "MVR" },
    { label: "MWK", value: "MWK" },
    { label: "MXN", value: "MXN" },
    { label: "MYR", value: "MYR" },
    { label: "MZN", value: "MZN" },
    { label: "NAD", value: "NAD" },
    { label: "NGN", value: "NGN" },
    { label: "NIO", value: "NIO" },
    { label: "NOK", value: "NOK" },
    { label: "NPR", value: "NPR" },
    { label: "NZD", value: "NZD" },
    { label: "OMR", value: "OMR" },
    { label: "PAB", value: "PAB" },
    { label: "PEN", value: "PEN" },
    { label: "PGK", value: "PGK" },
    { label: "PHP", value: "PHP" },
    { label: "PKR", value: "PKR" },
    { label: "PLN", value: "PLN" },
    { label: "PYG", value: "PYG" },
    { label: "QAR", value: "QAR" },
    { label: "RON", value: "RON" },
    { label: "RSD", value: "RSD" },
    { label: "RUB", value: "RUB" },
    { label: "RWF", value: "RWF" },
    { label: "SAR", value: "SAR" },
    { label: "SBD", value: "SBD" },
    { label: "SCR", value: "SCR" },
    { label: "SDG", value: "SDG" },
    { label: "SEK", value: "SEK" },
    { label: "SGD", value: "SGD" },
    { label: "SHP", value: "SHP" },
    { label: "SLL", value: "SLL" },
    { label: "SOS", value: "SOS" },
    { label: "SRD", value: "SRD" },
    { label: "SSP", value: "SSP" },
    { label: "STN", value: "STN" },
    { label: "SVC", value: "SVC" },
    { label: "SYP", value: "SYP" },
    { label: "SZL", value: "SZL" },
    { label: "THB", value: "THB" },
    { label: "TJS", value: "TJS" },
    { label: "TMT", value: "TMT" },
    { label: "TND", value: "TND" },
    { label: "TOP", value: "TOP" },
    { label: "TRY", value: "TRY" },
    { label: "TTD", value: "TTD" },
    { label: "TWD", value: "TWD" },
    { label: "TZS", value: "TZS" },
    { label: "UAH", value: "UAH" },
    { label: "UGX", value: "UGX" },
    { label: "USD", value: "USD" },
    { label: "UYU", value: "UYU" },
    { label: "UZS", value: "UZS" },
    { label: "VES", value: "VES" },
    { label: "VND", value: "VND" },
    { label: "VUV", value: "VUV" },
    { label: "WST", value: "WST" },
    { label: "XAF", value: "XAF" },
    { label: "XCD", value: "XCD" },
    { label: "XDR", value: "XDR" },
    { label: "XOF", value: "XOF" },
    { label: "XPF", value: "XPF" },
    { label: "XSU", value: "XSU" },
    { label: "YER", value: "YER" },
    { label: "ZAR", value: "ZAR" },
    { label: "ZMW", value: "ZMW" },
    { label: "ZWL", value: "ZWL" }
    ,]

export const ratingType = [
    { label: "Star", value: "star" },
    { label: "Opinion scale", value: "opinion" },
    { label: "Emoji", value: "emoji" },
    { label: "Thumbs up/down", value: "thumbs" },
    { label: "Slider Rating", value: "slider" }
]
